import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import Ionicons from 'react-native-vector-icons/Ionicons';
import {css} from 'styled-components/native';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';

interface ItemName {
  capitalize?: boolean;
}

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView`
  flex: 1;
`;

export const ContentTop = styled.View`
  margin: 0 24px;
`;

export const PlacaInfo = styled.View`
  margin-left: ${RFValue(12)}px;
  flex: 1;
`;
export const PlacaTitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.semibold};
`;
export const PlacaSubtitle = styled.Text`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ArrowIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const PlacaContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const PlacaColumn = styled.View`
  flex-direction: row;
  flex: 1;
  margin-right: ${RFValue(12)}px;
  align-items: center;
`;

export const ActiveAlertBox = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${RFValue(6)}px ${RFValue(12)}px;
  background-color: ${({theme}) => theme.colors.background_black};
  border-radius: ${RFValue(8)}px;
  margin-top: ${RFValue(12)}px;
`;
export const ActiveAlertTitle = styled.Text`
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const ActiveDebitSwitch = styled.Switch`
  transform: scale(0.8);
`;

export const DeleteVehicleContainer = styled.View`
  flex-direction: row;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-top-width: 1px;
  padding: ${RFValue(16)}px 24px;
`;

export const DeleteVehicleButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
`;

export const DeleteVehicleButtonIcon = styled(Ionicons)`
  font-size: ${RFValue(16)}px;
  margin-right: ${RFValue(8)}px;
  color: ${({theme}) => theme.colors.attention};
`;

export const DeleteVehicleButtonText = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.attention};
  margin-top: ${RFValue(2)}px;
`;

export const FipeArea = styled.View`
  flex-direction: column;

  align-items: center;
  justify-content: space-around;
  border-style: dashed;
  border-color: ${({theme}) => theme.colors.border};
  border-width: 3px;
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(12)}px;
`;

export const LabelFipe = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  justify-content: center;
  align-items: center;
`;
export const LabelTitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(12)}px;
  flex-wrap: wrap;
  flex-direction: row;
`;

export const ItemFipe = styled.Text<ItemName>`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;

  ${({capitalize}) =>
    capitalize &&
    css`
      text-transform: capitalize;
    `}
`;

export const SearchDebitsContainer = styled.View`
  flex-direction: row;
  border-style: solid;
  border-color: ${({theme}) => theme.colors.border};
  border-top-width: 1px;
  padding: ${RFValue(16)}px 24px;
  margin-top: ${RFValue(12)}px;
`;

export const SearchDebitsButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  flex: 1;
  justify-content: space-between;
`;

export const SearchDebitsContainerColumn = styled.View`
  flex-direction: row;
  align-items: center;
`;
export const SearchDebitsIcon = styled(FastImage)`
  width: ${RFValue(16)}px;
  height: ${RFValue(16)}px;
  margin-right: ${RFValue(8)}px;
`;
export const SearchDebitsText = styled.Text`
  font-family: ${({theme}) => theme.fonts.medium};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;
export const SearchDebitsArrowIcon = styled(Feather)`
  font-size: ${RFValue(14)}px;
  color: ${({theme}) => theme.colors.text_dark};
`;

export const Footer = styled.View`
  padding: 0 24px;
  padding-bottom: ${Platform.OS === 'ios' && getBottomSpace()
    ? getBottomSpace()
    : RFValue(20)}px;
`;

export const ConsultarFipeButton = styled.TouchableOpacity``;

export const ConsultarFipeText = styled.Text`
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.blue};
  font-size: ${RFValue(12)}px;
`;
